import { Icon, Tree, TreeNode } from "construct-ui";

/**
 * Basic Tree Component
 * 
 * Renders a tree
 * 
 * @author Darrus Goh
 */
export default function TreeComponent() {

  let expandedMap = new Map();

  let createExpandedMap = (items, callBack) => {
    if (!items) {
      return;
    }
    if (items.length > 0) {
      items.map((item) => {
        expandedMap.set(item.code, true);
        callBack(item.code);
        if (item.children.length > 0) {
          createExpandedMap(item.children, callBack);
        }
      });
    }
  };
  let handleNodeExpand = (node) => {
    expandedMap.set(node.key, true);
  }

  let handleNodeCollapse = (node) => {
    expandedMap.delete(node.key);
  }

  let handleNodeClick = (globalOnClick, localOnClick) => (node) => {
    const code = node.key;
    if (localOnClick) {
      localOnClick(code);
    } else if (globalOnClick) {
      globalOnClick(code);
    }
  }

  let renderNode = (item, selectedItem, globalOnClick) => {
    const { children = [], code, name, icon, class: _class, disabled, onClick } = item;
    const hasChildren = children.length > 0;

    return m(TreeNode, {
      children: children.map(child => renderNode(child, selectedItem, globalOnClick)),
      hasCaret: hasChildren,
      label: name,
      title: name,
      key: code,
      class: (_class ?? '') + (disabled ? 'placeholder-text-color' : ''),
      contentLeft: item.icon && m(Icon, { name: icon }),
      isExpanded: expandedMap.has(code),
      isSelected: selectedItem && selectedItem === code,
      onExpand: handleNodeExpand,
      onCollapse: handleNodeCollapse,
      onClick: !disabled && handleNodeClick(globalOnClick, onClick),
    });
  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.isOpenTheLastLevel) {
        createExpandedMap(vnode.attrs.items, vnode.attrs.getNodeDetail);
      }
    },
    view: ({ attrs: {
      class: _class = '',
      items = [],
      selectedItem = '',
      style = '',
      globalOnClick } }) => m(Tree, {
        class: _class,
        nodes: items.map(item => renderNode(item, selectedItem, globalOnClick)),
        style: style
      })
  }
}
